export enum ReactAppTypeEnum {
    LOCAL = 'local',
    PRODUCTION = 'production',
    DEVELOPMENT = 'development',
}
